import React from 'react';
import { Divider, FormInstance, Row } from 'antd';
import FormInput from 'components/FormInput';
import AssetUpload from 'components/AssetUpload';
import DF from 'DisplayFramework';
import GetLabel from 'DisplayFramework/components/GetLabel';

export type AssetFeesPicturesProps = {
  form: FormInstance;
};

const AssetFeesPictures = ({ form }: AssetFeesPicturesProps) => {
  return (
    <DF.Provider pagcode="assetCatalogPictures">
      <Divider orientation="left">
        <GetLabel label="before" />
      </Divider>

      <Row gutter={32}>
        <FormInput col xs={24} lg={4} onlylabel="picture1before">
          <AssetUpload
            catalogid={form.getFieldValue('feesid')}
            picid={4}
            objectreference={form.getFieldValue('assetreference')}
            name="picture1before"
            form={form}
          />
        </FormInput>
        <FormInput col xs={24} lg={4} onlylabel="picture2before">
          <AssetUpload
            catalogid={form.getFieldValue('feesid')}
            objectreference={form.getFieldValue('assetreference')}
            picid={5}
            name="picture2before"
            form={form}
          />
        </FormInput>
        <FormInput col xs={24} lg={4} onlylabel="picture3before">
          <AssetUpload
            catalogid={form.getFieldValue('feesid')}
            objectreference={form.getFieldValue('assetreference')}
            picid={6}
            name="picture3before"
            form={form}
          />
        </FormInput>
      </Row>

      <Divider orientation="left">
        <GetLabel label="after" />
      </Divider>
      <Row gutter={32}>
        <FormInput col xs={24} lg={4} onlylabel="picture1after">
          <AssetUpload
            catalogid={form.getFieldValue('feesid')}
            objectreference={form.getFieldValue('assetreference')}
            picid={1}
            name="picture1after"
            form={form}
          />
        </FormInput>
        <FormInput col xs={24} lg={4} onlylabel="picture2after">
          <AssetUpload
            catalogid={form.getFieldValue('feesid')}
            objectreference={form.getFieldValue('assetreference')}
            picid={2}
            name="picture2after"
            form={form}
          />
        </FormInput>
        <FormInput col xs={24} lg={4} onlylabel="picture3after">
          <AssetUpload
            catalogid={form.getFieldValue('feesid')}
            objectreference={form.getFieldValue('assetreference')}
            picid={3}
            name="picture3after"
            form={form}
          />
        </FormInput>
      </Row>
    </DF.Provider>
  );
};

export default AssetFeesPictures;
